import {
  GET_USERS_URL,
  GET_USER_URL,
  CREATE_USER_URL,
  UPDATE_USER_URL,
  UPDATE_USER_ACCESS_CONTROL_URL,
} from "../../config/Url";
import { BazaarHttpClient } from "../http/BazaarHttpClient";
import {
  IcreateUserPayload,
  IAddUpdateCustomerPageState,
  IFilterPayload,
} from "../../interfaces/Index";
import { organizationIds } from "config/constants";

export class UserSource {
  private key: string = "{user_id}";

  public constructor(private client: BazaarHttpClient) {}

  public createUser(user: UserAddUpdateDto): Promise<UserInfoDto> {
    return this.client.post(CREATE_USER_URL, user);
  }

  public updateUserForAccessControl(id: string, user: UserAddUpdateDto): Promise<UserInfoDto> {  
    const url = UPDATE_USER_ACCESS_CONTROL_URL.replace(this.key, id);
    return this.client.put(url, user);
  }

  public updateUser(id: string, user: UserAddUpdateDto): Promise<UserInfoDto> {  
    const { ["id"]:uid, accountStatus, phoneNumber, ...updatedUserFields } = user;
    const url = UPDATE_USER_URL.replace(this.key, id);
    return this.client.put(url, updatedUserFields);
  }

  public getUsers(): Promise<Array<UserInfoDto>> {
    return this.client.get(GET_USERS_URL);
  }

  public getUser(id: string): Promise<UserInfoDto> {
    const url = GET_USER_URL.replace(this.key, id);
    return this.client.get(url);
  }
}

export default new UserSource(new BazaarHttpClient());

export enum CountryCode {
  PK = "PK",
}

export enum AccountStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}

export class UserAddUpdateDto {
  public countryCode: CountryCode;

  public constructor(
    public id: string,
    public fullName: string,
    public phoneNumber: string,
    public password: string,
    public passwordConfirmation: string,
    public accountStatus: AccountStatus,
    public nationalId: string,
    public email?: string,
    public organizationId?: string,
    public filters?: Array<IFilterPayload>
  ) {
    this.fullName = fullName;
    this.phoneNumber = phoneNumber;
    this.password = password;
    this.passwordConfirmation = passwordConfirmation;
    this.nationalId = nationalId;
    this.accountStatus = accountStatus;
    this.countryCode = CountryCode.PK;
    this.email = email;
    this.organizationId = organizationId;
    this.filters = filters;
  }
  public static fromCreateDto(id: any, dto: IcreateUserPayload) {
    return new UserAddUpdateDto(
      id,
      String(dto.name),
      String(dto.phone).trim(),
      String(dto.password),
      String(dto.passwordConfirmation),
      AccountStatus.ENABLED,
      String(dto.nationalId),
      String(dto.email || ""),
      String(dto.organizationId || organizationIds[1].id),
      dto.filters as any // IFilterPayload[] yeh khud laga lena
    );
  }

  public static fromRiderCreateDto(id: any, dto: IcreateUserPayload) {
    return new UserAddUpdateDto(
      id,
      String(dto.name),
      String(dto.phone),
      String(dto.password),
      String(dto.passwordConfirmation),
      AccountStatus.ENABLED,
      String(dto.nationalId),
      String(dto.email)
    );
  }

  public static fromUpdateDto(
    id: string,
    dto: IAddUpdateCustomerPageState
  ): UserAddUpdateDto {
    const status =
      dto.status === "ACTIVE" || dto.status === "ENABLED"
        ? AccountStatus.ENABLED
        : AccountStatus.DISABLED;
    return new UserAddUpdateDto(
      id,
      dto.name,
      dto.phone.trim(),
      dto.password,
      dto.passwordConfirmation,
      status,
      dto.nationalId,
      dto.email,
      dto.organizationId,
      dto.filters
    );
  }

  public static userUpdateDto(
    id: string,
    dto: IAddUpdateCustomerPageState
  ): UserAddUpdateDto {
    const status =
      dto.userStatus === "ACTIVE" || dto.userStatus === "ENABLED"
        ? AccountStatus.ENABLED
        : AccountStatus.DISABLED;
    return new UserAddUpdateDto(
      id,
      dto.name,
      dto.phone.trim(),
      dto.password,
      dto.passwordConfirmation,
      status,
      dto.nationalId,
      dto.email
    );
  }
}

export class UserInfoDto {
  public constructor(
    public id: string,
    public fullName: string,
    public phoneNumber: string,
    public email: string,
    public nationalId: string,
    public countryCode: CountryCode,
    public accountStatus: AccountStatus
  ) {}
}
